import { useEffect, useState } from "react";
import { useFiltersStore } from "~/stores";
import { FilterOption } from "~/types/filters.types";

const useCompanyFilters = () => {
    const companies = useFiltersStore(state => state.companyFilters);
    const isLoading = useFiltersStore(state => state.isLoadingCompanyFilters);

    const [filteredCompanies, setFilteredCompanies] = useState<FilterOption[]>(companies);
    const [search, setSearch] = useState<string>("");

    const checkKeywordMatch = (label: string, keyword: string) =>
        label.toLowerCase().includes(keyword.trim().toLowerCase());

    useEffect(() => {
        let result = [...companies];

        if (search) {
            result = companies.filter(company =>
                checkKeywordMatch(company.label as string, search)
            );
        }
        setFilteredCompanies(result);
    }, [companies, search]);

    return {
        companies: filteredCompanies,
        isLoading,
        search,
        setSearch
    };
};

export default useCompanyFilters;
